import { SERVER_URL } from '../constants';
import { CreateTuaPayUrlParams, CreateTuaPayUrlResponse, ITuaPayResponseError, TuapayTransactionRequest } from '../types';


export const createTuaPayUrl = async ({
  clientId,
  payPageId,
  session,
}: CreateTuaPayUrlParams): Promise<CreateTuaPayUrlResponse> => {
  const res = await fetch(`${SERVER_URL}/TuaPay/CreateUrl`, {
    method: 'POST',
    body: JSON.stringify({ clientId, payPageId, session }),
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  });

  if (res.status !== 200) {
    throw new Error('merchant_validation_failed');
  }

  const result = await res.json();
  return result;
};

export const performTuaPayTransaction = async (
  body: TuapayTransactionRequest,
  { payPage, session, clientId }: {
    payPage: string;
    session: string;
    clientId: string;
  },
): Promise<boolean | ITuaPayResponseError> => {
  const res = await fetch(`${SERVER_URL}/TuaPay/HandleResult?${new URLSearchParams({
    ClientId: clientId,
    PayPageId: payPage,
    Session: session,
  }).toString()}`, {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    },
  });

  if (res.status !== 200) {
    throw new Error('payment_error_happened');
  }

  const result = await res.json();

  return result;
};
